import { ImagePortrait, RatingStars } from '@touche-lts/panel-ui/dist'
import styles from './home.module.scss'
import storeStyles from '../stores/stores-page/store-page/store-page.module.scss'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import cl from 'classnames'
import AvatarEditor from 'react-avatar-editor'
import { Department } from 'models/departments'

const HomePageComponent = () => {
    const defaultImageSrc = 'https://st2.depositphotos.com/4403291/7418/v/600/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
        {
            storesPublic: {
                onSearchStore,
                pageStores
            },
            departmentsStore: {
                allDepartments
            },
            generalStore: {
                api: {
                    statisticsApi
                }
            },
            routingStore: { push }
        } = useRootStore(),
        [searchStore, setSearchStore] = useState<string>(''),
        [topStoreProducts, setTopStoreProducts] = useState<any>(),

        searchHandle = (ev) => {
            const searchedValue = ev.target.value;
            setSearchStore(searchedValue)
            onSearchStore(searchedValue)
        },

        getStoreStats = async () => {
            const topStoreProducts = await statisticsApi.getTopStoreProducts();
            if (!topStoreProducts) return;
            setTopStoreProducts(topStoreProducts);
        }

    useEffect(() => {
        getStoreStats()
    }, []);

    return (
        <>
            <div className={styles.homeBackgroundDepartment}>
                <div className={styles.homeBackground}>
                    <div className='container'>
                        <h1>Browse products</h1>
                        <p>{topStoreProducts?.productsCount} products</p>
                        <input
                            placeholder='Search for a store...'
                            value={searchStore}
                            onChange={(ev) => searchHandle(ev)}
                        />
                    </div>
                </div>
                <div className={styles.homePageContainer}>
                    {!searchStore.length ? (
                        <>
                            <h1>Shop by Department</h1>
                            <div className={styles.departmentContainerImage}>
                                {allDepartments?.slice(0, 10)?.map((department: Department) => {
                                    return (
                                        <div onClick={() => push('/departments/' + department?.id)}>
                                            <AvatarEditor
                                                image={department?.squareCrop?.url}
                                                width={256}
                                                height={256}
                                                border={0}
                                                scale={department?.squareCrop?.squareWidth}
                                                position={{ x: department?.squareCrop?.squareX, y: department?.squareCrop?.squareY }}
                                                rotate={0}
                                                className={styles.departmentImage}
                                            />
                                            <span>{department?.name}</span>
                                        </div>
                                    )
                                })}
                            </div>
                            <h2 onClick={() => push('/departments')}>View all</h2>
                        </>
                    ) : (
                        <div className={storeStyles.storesContainer}>
                            {pageStores?.content?.map(product => {
                                return (
                                    <div className={storeStyles.productInfo} onClick={() => push(`/product/${product.id}`)}>
                                        <div className={storeStyles.productInfoDetails}>
                                            <ImagePortrait width={176} height={176} src={!!product?.images?.length ? product?.images[0]?.url : defaultImageSrc} />
                                            <div className={storeStyles.productInfoDetailsText}>
                                                <h2>{product.name}</h2>
                                                <RatingStars rating={product?.rating}
                                                    reviewsCnt={product?.reviewsCnt} />
                                                <small>Add to cart</small>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
            <div className={cl('d-flex', 'flex-column')}>
                <div className={styles.homePageContainer}>
                    <h1>Our bestellers</h1>
                    <div className={cl(storeStyles.storesContainer, 'justify-content-center')}>
                        {topStoreProducts?.bestSellingProducts?.map((product, index) => {
                            return (
                                <div key={`bestSelling-${index}`} className={storeStyles.productInfo} onClick={() => push(`/product/${product.id}`)}>
                                    <div className={storeStyles.productInfoDetails}>
                                        <ImagePortrait width={176} height={176} src={!!product?.images?.length ? product?.images[0]?.url : defaultImageSrc} />
                                        <div className={storeStyles.productInfoDetailsText}>
                                            <h2>{product.name}</h2>
                                            <RatingStars rating={product?.rating}
                                                reviewsCnt={product?.reviewsCnt} />
                                            <small>Add to cart</small>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <h1>New products</h1>
                    <div className={cl(storeStyles.storesContainer, 'justify-content-center')}>
                        {topStoreProducts?.newProducts?.map(product => {
                            return (
                                <div className={storeStyles.productInfo} onClick={() => push(`/product/${product.id}`)}>
                                    <div className={storeStyles.productInfoDetails}>
                                        <ImagePortrait width={176} height={176} src={!!product?.images?.length ? product?.images[0]?.url : defaultImageSrc} />
                                        <div className={storeStyles.productInfoDetailsText}>
                                            <h2>{product.name}</h2>
                                            <RatingStars rating={product?.rating}
                                                reviewsCnt={product?.reviewsCnt} />
                                            <small>Add to cart</small>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <h1>Top rated stores</h1>
                    <div className={cl(storeStyles.storesContainer, 'justify-content-center')}>
                        {topStoreProducts?.topRatedStores?.map(product => {
                            return (
                                <div className={storeStyles.productInfo} onClick={() => push(`/product/${product.id}`)}>
                                    <div className={storeStyles.productInfoDetails}>
                                        <ImagePortrait width={176} height={176} src={!!product?.images?.length ? product?.images[0]?.url : defaultImageSrc} />
                                        <div className={storeStyles.productInfoDetailsText}>
                                            <h2>{product.name}</h2>
                                            <RatingStars rating={product?.rating}
                                                reviewsCnt={product?.reviewsCnt} />
                                            <small>Add to cart</small>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <h2 onClick={() => push('/stores')}>See all</h2>
                </div>
            </div>
        </>
    )
},

    HomePage = observer(HomePageComponent)
export { HomePage }
